import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Avatar,
  Menu,
  MenuItem,
  Button,
  List,
  ListItem,
  ListItemText,
  ListItemButton,
  RadioGroup,
  FormControlLabel,
  Radio,
  Paper,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import logo from '../../assets/images/logo.png';
import { useNavigate } from "react-router-dom";
import { API_PATH } from "../../environments";
const avatarImage = "/path/to/avatar.png";
const signup = "/path/to/background.jpg";

const domains = ["DevOps", "SRE"];
const navLinks = ["Maturity Assessment", "Contact Us"];

function getUserTimeZone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

function getGreeting(timeZone) {
  const now = new Date();
  const userTimeStr = now.toLocaleString("en-US", {
    timeZone,
    hour12: false,
    hour: "2-digit",
  });
  const userHour = parseInt(userTimeStr, 10);

  if (userHour >= 5 && userHour < 12) {
    return "Good Morning!";
  } else if (userHour >= 12 && userHour < 17) {
    return "Good Afternoon!";
  } else {
    return "Good Night!";
  }
}

export default function SreQuestions() {
  const [currentDomain, setCurrentDomain] = useState("DevOps");
  const [timeZone, setTimeZone] = useState("UTC");
  const [greeting, setGreeting] = useState("Hello!");
  const [userMenuAnchor, setUserMenuAnchor] = useState(null);
  const [questions, setQuestions] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const tz = getUserTimeZone();
    setTimeZone(tz);
    setGreeting(getGreeting(tz));
  }, []);

  // Fetch questions when currentDomain changes
  useEffect(() => {
    if (currentDomain === "SRE") {
      // http://localhost:8085/api/questions/filter?userRole=Technical&domain=${currentDomain}
      fetch(
        `${API_PATH}/questions/filter?userRole=Technical&domain=${currentDomain}`
      )
        .then((res) => res.json())
        .then((data) => {
          setQuestions(data.questions || []);
        })
        .catch((err) => {
          console.error("Failed to fetch questions:", err);
          setQuestions([]);
        });
    } else {
      // If domain is not SRE, clear questions or fetch different endpoint if needed
      setQuestions([]);
    }
  }, [currentDomain]);

  const handleNavLinkClick = (e,idx) => {
        const appBarTitle = e.target.innerText;
        if(appBarTitle === "Maturity Assessment"){
        navigate(`/sre-score?domain=${encodeURIComponent(currentDomain)}&email=${encodeURIComponent("")}&name=${encodeURIComponent("")}/`);
        }
        else{
        navigate(`/contactus-page`)
        }
    }

  const handleDomainClick = (domain) => {
    setCurrentDomain(domain);
  };

  const handleUserMenuOpen = (event) => {
    setUserMenuAnchor(event.currentTarget);
  };
  const handleUserMenuClose = () => {
    setUserMenuAnchor(null);
  };

  return (
    <>
          {/* Background Image */}
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              backgroundImage: `url(${signup})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              zIndex: 0,
            }}
          />

          {/* Overlay */}
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              pointerEvents: "none",
              background:
                "conic-gradient(from -7.72deg at 100% 100%, rgba(31, 42, 84, 0.5) 0deg, rgba(0, 0, 0, 0.5) 294.45deg, rgba(31, 42, 84, 0.5) 360deg)",
              backdropFilter: "blur(20px)",
              WebkitBackdropFilter: "blur(20px)",
              zIndex: 1,
            }}
          />

          {/* Questions container */}
          <Box
            sx={{
              position: "relative",
              zIndex: 2,
              backgroundColor: "rgba(255, 255, 255, 0.15)",
              backdropFilter: "blur(15px)",
              WebkitBackdropFilter: "blur(15px)",
              boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
              border: "1px solid rgba(255, 255, 255, 0.3)",
              borderRadius: "16px",
              padding: 3,
              maxHeight: "90vh",
              overflowY: "auto",
            }}
          >
            {questions.length === 0 && currentDomain === "SRE" ? (
              <Typography
                variant="body1"
                sx={{  fontSize: "1rem", color: "#fff" }}
              >
                Loading questions...
              </Typography>
            ) : questions.length === 0 ? (
              <Typography
                variant="body1"
                sx={{  fontSize: "1rem", color: "#fff" }}
              >
                No questions available for {currentDomain}.
              </Typography>
            ) : (
              questions.map((q) => {
                const options = q.optionText.split(",").map((opt) => opt.trim());

                return (
                  <Paper
                    key={q.questionId}
                    sx={{
                      mb: 3,
                      p: 2,
                      backgroundColor: "rgba(255, 255, 255, 0.25)",
                      
                    }}
                    elevation={3}
                  >
                    <Typography
                      variant="h6"
                      sx={{ fontSize: "1.1rem", mb: 1, color: "#333" }}
                    >
                      {q.question}
                    </Typography>
                    <RadioGroup
                      name={`question-${q.questionId}`}
                      sx={{ color: "#1976d2" }}
                    >
                      {options.map((option, idx) => (
                        <FormControlLabel
                          key={idx}
                          value={option}
                          control={<Radio />}
                          label={option}
                          sx={{
                            "& .MuiFormControlLabel-label": {
                              
                              fontSize: "1rem",
                            },
                          }}
                        />
                      ))}
                    </RadioGroup>
                  </Paper>
                );
              })
            )}
          </Box>
    </>

  );
}
